import * as TYPES from './ar-invitation-actiontypes';

export const initialState = {
  arInvitation: {},
  arInvitationExists: false,
  prevRoute: '',
};

export const arInvitationReducer = (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case TYPES.SET_AUTHORIZED_REP_INVITATION:
      newState = { ...state,
        arInvitation: action.arInvitation };
      break;
    case TYPES.SET_AR_INVITATION_EXISTS:
      newState = { ...state, arInvitationExists: action.arInvitationExists };
      break;
    case TYPES.SET_PREV_ROUTE_BEFORE_INVITE:
      newState = { ...state, prevRoute: action.prevRoute };
      break;
    default:
      newState = state;
  }

  return newState;
};

export default arInvitationReducer;
